export const CALENDAR_COLORS = {
  // Colores principales para eventos - Matching CustomEvent.tsx SLOT_STYLES
  events: {
    // Eventos individuales - Azul original
    individual: {
      background: '#0072ff',
      text: '#ffffff',
      border: 'none',
      hover: '#0062e6'
    },

    // Eventos grupales - Verde claro original  
    default: {
      background: '#CEf7EC',
      text: '#212121',
      border: '#CEf7EC',
      hover: '#b8f1e1'
    },

    // Eventos pendientes - Amarillo original
    pending: {
      background: '#ffe77b',
      text: '#00000080',
      border: '#ffe77b',
      hover: '#ffd54f'
    },

    // Eventos cancelados - Rosa claro original
    canceled: {
      background: '#ffe3e6',
      text: '#ff4658',
      border: '#ffe3e6',
      hover: '#ffcdd2'
    },

    // Eventos pausados - Amarillo igual que pending
    paused: {
      background: '#ffe77b',
      text: '#00000080',
      border: '#ffe77b',
      hover: '#ffd54f'
    },

    // Horarios de trabajo - Azul con transparencia original
    workingHour: {
      background: '#0072FF40',
      text: '#0072FB',
      border: '#0072FF40',
      hover: '#0072FF60'
    },

    // Horarios bajo demanda - Azul con transparencia original
    onDemandHour: {
      background: '#0072FF40',
      text: '#0072FB',
      border: '#0072FF40',
      hover: '#0072FF60'
    },

    // Eventos únicos - Negro original
    unique: {
      background: '#212121',
      text: '#ffffff',
      border: '#212121',
      hover: '#424242'
    },

    // Horarios bloqueados - Gris con transparencia original
    blocked: {
      background: '#D9D9D9E5',
      text: '#212121',
      border: '#D9D9D9E5',
      hover: '#D9D9D9'
    },

    // Buffer time - Gris con transparencia y patrón original
    buffer: {
      background: '#D9D9D9E5',
      text: '#212121',
      border: '#727272',
      hover: '#D9D9D9',
      borderStyle: 'dashed'
    }
  },

  // Colores para la vista por recursos (staff)
  resources: {
    colors: [
      '#1976D2', // Azul
      '#388E3C', // Verde
      '#F57C00', // Naranja
      '#7B1FA2', // Púrpura
      '#C2185B', // Rosa
      '#00796B', // Teal
      '#5D4037', // Marrón
      '#455A64', // Gris azulado
      '#E65100', // Naranja profundo
      '#4527A0' // Índigo
    ],

    // Colores de fondo suaves para las columnas de recursos
    backgrounds: [
      '#E3F2FD',
      '#E8F5E8',
      '#FFF3E0',
      '#F3E5F5',
      '#FCE4EC',
      '#E0F2F1',
      '#EFEBE9',
      '#ECEFF1',
      '#FFF3E0',
      '#EDE7F6'
    ]
  },

  // Colores del calendario base
  calendar: {
    // Fondo principal
    background: '#FFFFFF',

    // Líneas de grilla - más suaves
    gridLines: '#E8EAED',

    // Cabeceras de días
    dayHeader: {
      background: '#F8F9FA',
      text: '#3C4043',
      border: '#E8EAED'
    },

    // Indicadores de tiempo
    timeLabels: {
      text: '#5F6368',
      background: '#F8F9FA'
    },

    // Día actual
    today: {
      background: '#E8F0FE',
      indicator: '#1976D2'
    },

    // Día pasado
    past: {
      text: '#9AA0A6',
      background: '#F8F9FA'
    },

    // Hover states
    hover: {
      background: '#F1F3F4',
      border: '#DADCE0'
    }
  },

  // Estados interactivos
  interactive: {
    // Botones y controles
    primary: '#1976D2',
    primaryHover: '#1565C0',

    // Enlaces y acciones secundarias
    secondary: '#5F6368',
    secondaryHover: '#3C4043',

    // Estados de éxito
    success: '#2E7D32',
    successHover: '#1B5E20',

    // Estados de advertencia
    warning: '#F57C00',
    warningHover: '#EF6C00',

    // Estados de error
    error: '#D32F2F',
    errorHover: '#C62828'
  },

  // Colores para leyenda de estados
  legend: {
    disponible: '#4285F4', // Azul Google
    personalizado: '#1976D2', // Azul más oscuro
    evento: '#37474F', // Gris oscuro
    grupal: '#0F9D58', // Verde Google
    cancelado: '#EA4335' // Rojo Google
  }
};

/**
 * Función para obtener el color de un recurso (staff member) basado en su ID
 */
export const getResourceColor = (vendorId: number): string => {
  const colors = CALENDAR_COLORS.resources.colors;
  return colors[vendorId % colors.length];
};

/**
 * Función para obtener el color de fondo de un recurso
 */
export const getResourceBackground = (vendorId: number): string => {
  const backgrounds = CALENDAR_COLORS.resources.backgrounds;
  return backgrounds[vendorId % backgrounds.length];
};

/**
 * Estilos específicos para efectos hover (sin transformaciones de escala)
 */
export const HOVER_EFFECTS = {
  // Efecto hover suave para eventos
  event: `
    transition: all 0.2s ease-in-out;
    &:hover {
      filter: brightness(0.95);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    }
  `,

  // Efecto hover para controles
  control: `
    transition: all 0.15s ease-in-out;
    &:hover {
      background-color: var(--hover-bg);
      border-color: var(--hover-border);
    }
  `,

  // Efecto hover para celdas del calendario
  cell: `
    transition: background-color 0.15s ease-in-out;
    &:hover {
      background-color: #F1F3F4;
    }
  `
};
